<template >
  <div>
    <div v-if="loader" id="loader"></div>
    <div class="sm-grid">
      <Grid
        ref="grid"
        v-bind:style="{ height: gridHeight + 'px' }"
        :data-items="items"
        :columns="columns"
        :sortable="true"
        :sort="sort"
        :pageable="pageable"
        :skip="skip"
        :take="take"
        :total="total"
        :page-size="pageSize"
        @pagechange="pageChangeHandler"
        @sortchange="sortChangeHandler"
        :resizable="true"
        :expand-field="'expanded'"
        :detail="detailComponent"
        @expandchange="expandChange"
        @Acknowledge="Acknowledge"
      >
        <grid-toolbar>
          <div class="searchbox">
            <input
              type="text"
              v-model="searchText"
              class="form-control search_mobile"
              placeholder="Search"
            />
          </div>
        </grid-toolbar>
      </Grid>
    </div>
  </div>
</template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import DetailComponent from "./DetailComponent.vue";
import Vue from "vue";
import { formatAMPMTime, formatTime } from "@/utils/date-helpers";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("deviceMonitoring");
import Acknowledge from "../ListSos/Acknowledgement.vue";
import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError } from "@/utils/notification-helper";

export default {
  data() {
    return {
      gridHeight: window.innerHeight - 150,
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        pageSizes: [5, 10, 25, 100, 500],
      },
      searchText: "",
      sort: [{ field: "name", dir: "asc" }],
      detailComponent: DetailComponent,
      columns: [
        {
          hidden: false,
          field: "imei",
          title: "IMEI",
          width: "150px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "tenantId",
          title: "Tenant",
          cell: this.tenantName,
          width: "120px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "deviceType",
          title: "Device Type",
          width: "100px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "assetRefNo",
          title: "Vehicle Number",
          width: "120px",
          checked: true,
          defaultSelected: true,
        },
        // {
        //   hidden: false,
        //   field: "sensor",
        //   title: "Sensor",
        //   width: "150px",
        //   checked: true,
        //   defaultSelected: false,
        // },
        {
          hidden: false,
          field: "dateTime",
          title: "Date Time",
          cell: this.getTimeZ,
          width: "150px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "reason",
          title: "Reason",
          width: "150px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "faultType",
          title: "Fault Type",
          width: "150px",
          checked: true,
          defaultSelected: false,
        },
        { cell: Acknowledge, title: "Actions", locked: "true", width: "150px" },
      ],
    };
  },
  methods: {
    sortChangeHandler: function (e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function (event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    expandChange(event) {
      const isExpanded =
        event.dataItem.expanded === undefined
          ? event.dataItem.aggregates
          : event.dataItem.expanded;
      Vue.set(event.dataItem, "expanded", !isExpanded);
    },
    async getDataOnload() {
      this.$store.dispatch("deviceMonitoring/getDeviceMonitoringData");
      this.$store.dispatch("deviceMonitoring/getInitialData");
    },
    getTimeZ: function (h, tdElement, props) {
      const field = props.field;
      var date = props.dataItem[field];
      if (!date) {
        return h("td", {}, "");
      }
      let val = this.isTimeformat
        ? formatTime(new Date(date))
        : formatAMPMTime(new Date(date));
      return h("td", {}, val);
    },
    tenantName: function (h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "");
      }
      const tenant = this.getIntialData.tenants.find(
        (tenant) => tenant.tenantId === value
      );
      return h("td", {}, tenant ? tenant.name : "");
    },
    Acknowledge(e) {
      this.$store
        .dispatch(
          "deviceMonitoring/acknowledgeDeviceMonitorData",
          e.dataItem.imei
        )
        .then(() => {
          notify(MESSAGES.CHANGES_SAVE_SUCCESS);
        })
        .catch(notifyApiError);
    },
  },
  created: function() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type == "setSeclectedFacility") {
        // this.loadVendor();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
    this.getDataOnload();
  },
  computed: {
    ...mapState(["loader"]),
    total() {
      return this.gridData ? this.gridData.length : 0;
    },
    gridData() {
      return this.$store.getters["deviceMonitoring/deviceMonitorData"];
    },
    getIntialData() {
      return this.$store.getters["deviceMonitoring/getInitialData"];
    },
    isTimeformat() {
      return this.$store.state.isTimeFormat;
    },
    items: {
      get: function () {
        return orderBy(
          this.gridData.filter(
              (data) =>
                  JSON.stringify(data)
                  .toLowerCase()
                  .indexOf(this.searchText.toLowerCase()) != -1
            )
            .slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.searchbox {
  float: right;
}
</style>